export const EXPORT_MODEL = "report";

const exportModel = {
  id: 0,
  title: "",
  description: ""
};

export default exportModel;
